import { AllPageInfoFragment } from '@dtx-company/flow-codegen/src/page/generated.types'
import {
  fetchByBatchId,
  fetchByDirectoryId,
  fetchByPageId,
  fetchByPageTemplateId,
  fetchBySubdomainId
} from './useGetPermissions.utils'
import type {
  CollaboratorsType,
  EntityPermissionsType
} from '@dtx-company/inter-app/src/types/permissions'

type AssetIdObj = {
  batchId?: string
  directoryId?: string
  pageId?: string
  subdomainId?: string
  pageTemplateId?: string
}

export interface FetchPermissionsArgs {
  assetIdObj: AssetIdObj
  isBatch: boolean
  token?: string
  ithacaId?: string
  thisPage?: AllPageInfoFragment | null
}

export interface FetchPermissionsResult {
  isOwner: boolean
  entityPermissions: EntityPermissionsType[]
  existingCollaborators: CollaboratorsType[]
  ownerFullName: string
  ownerEntityId: string
}

const defaultResult: FetchPermissionsResult = {
  isOwner: true,
  entityPermissions: [],
  existingCollaborators: [],
  ownerFullName: '',
  ownerEntityId: ''
}

export async function fetchPermissions({
  assetIdObj,
  isBatch,
  token,
  ithacaId,
  thisPage
}: FetchPermissionsArgs): Promise<FetchPermissionsResult> {
  const { batchId, directoryId, pageId, subdomainId, pageTemplateId } = assetIdObj
  if (pageId) {
    return fetchByPageId(pageId, thisPage)
  }
  if (isBatch && batchId && token) {
    return fetchByBatchId(batchId, token)
  }
  if (directoryId) {
    return fetchByDirectoryId(directoryId)
  }
  if (pageTemplateId && token && ithacaId) {
    return fetchByPageTemplateId(pageTemplateId, token, ithacaId)
  }
  if (subdomainId) {
    return fetchBySubdomainId(subdomainId, isBatch)
  }
  return defaultResult
}
